<template>
  <router-link :to="{ name: 'home' }">
    <img src="../../assets/img/svg/ebanx-logo.svg" alt="EBANX" class="logo">
  </router-link>
</template>

<script>
export default {
  name: "Logo"
};
</script>
